const newEquipment = {
  plant: "Planta",
  equipment: "Crear un Nuevo Equipo",
  backbtn: "Atrás",
  modulesButton: "Módulos",
  equipmentTag: "Tag de Equipo",
  mechanical: "Código de Sello Mecánico",
  customer: "Cliente",
  equipmentType: "Tipo de Equipo",
  typeContract: "Tipo de Contrato",
  equipmentStatus: "Estatus del Equipo",
  statuslights: {
    running: "En Servicio",
    standby: "En Reposo",
    maintenance: "En Mantenimiento",
    failure: "Fallando"
  },
  tabs: {
    info: "INFORMACION BÁSICA",
    values: "VALORES OPERACIONALES",
    ranges: "RANGOS DE VARIABLE"
  },
  area: "Área",
  unit: "Unidad",
  location: "Seleccionar Ubicación",
  selectPlant: "Seleccionar Planta",
  selectArea: "Seleccionar Área",
  selectUnit: "Seleccionar Unidad",
  sealTypes: "Tipo de sello mecánico",
  hazardous: "Clasificación de área peligrosa",
  createdBy: "Creado Por",
  dateCreated: "Fecha de Creación",
  comment: "Comentario",
  pumpHousing: "Carcasa de la bomba",
  deleteEquipment: "Eliminar equipo",
  snackText: "Su equipo se ha creado con éxito",
  submit: "Enviar",
  picture: "Imagen",
  machineHealthIndex: "Índice de Salud del Equipo",
  mechanicalCondition: "Condición Mecánica del Equipo",
  manufacturer: "Fabricante",
  model: "Modelo"
};
export default newEquipment;
